export default __webpack_public_path__ + "static/media/lm-logo.3802b2b6.png";